import {useMutation} from '@tanstack/react-query'

import {UserRequest, UserResponse} from '../user'
import {login, register, callbackLogin, callbackToken} from './api'
import {LoginRequest, LoginResponse, OAuthTokenResponse} from './types'

export const useLogin = () => {
  return useMutation<LoginResponse, unknown, LoginRequest>({
    mutationFn: login,
  })
}

export const useRegister = () => {
  return useMutation<UserResponse, unknown, UserRequest>({
    mutationFn: register,
  })
}

export const useCallbackLogin = () => {
  return useMutation<LoginResponse, unknown, string>({
    mutationFn: callbackLogin,
  })
}

export const useCallbackToken = () => {
  return useMutation<OAuthTokenResponse, unknown, string>({
    mutationFn: (code: string) => callbackToken(code),
  })
}
